// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Section a bandeau gris pliable, ouverte par defaut (memes codes que les sections existantes). */
.section-pliable {
  margin: 0 0 2rem 0;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

/* --- Debordement autorise (prop \`overflowVisible\`) ------------------------------
   \`.section-pliable\` clippe son contenu : c'est ce clip qui arrondit le bas de la carte, le bloc de
   contenu ayant un fond blanc a angles droits. Le meme clip coupe toute liste flottante en position
   absolue — l'autocompletion d'adresse IGN devient illisible des que son champ est le dernier de la
   section. L'opt-in leve le clip et redonne l'arrondi au bloc de contenu, qui devient alors le
   dernier element visible de la carte : le rendu est identique, la liste n'est plus tronquee. */
.section-pliable--overflow-visible {
  overflow: visible;
}

.section-pliable--overflow-visible > .section-pliable-content {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.section-pliable-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  /* Aligne sur .section-header (TabDocuments.css) : padding 0.75rem 1rem, texte 1.4rem. */
  padding: 0.75rem 1rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #595959;
  color: #ffffff;
  font-size: 1.4rem;
  font-weight: 600;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.section-pliable-title {
  flex: 1 1;
  min-width: 0;
}

.section-pliable-right {
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  flex-shrink: 0;
}

/* Comportement haut/bas : ouverte = fleche vers le HAUT, repliee = fleche vers le BAS. */
.section-pliable-chevron {
  transition: transform 0.2s ease;
  transform: rotate(180deg);
}
.section-pliable-chevron.is-closed {
  transform: rotate(0deg);
}

.section-pliable-content {
  padding: 1.5rem;
  background: #fff;
}

/* Sections converties qui conservent un wrapper .section-content interne
   (Presentation, Bancaire, References) : SectionPliable porte deja padding +
   fond. On neutralise le wrapper interne pour eviter double padding / fond gris
   et uniformiser avec les autres onglets. */
.section-pliable-content > .section-content {
  padding: 0;
  background: transparent;
  /* .section-content global (App.css) porte aussi border + border-radius + margin-bottom :
     a neutraliser sinon double bordure dans la carte + espace residuel sous le contenu. */
  border: none;
  border-radius: 0;
  margin: 0;
}

/* Modale profil membre : les onglets ReadOnly enveloppent leur contenu dans .readonly-section-content
   (padding + fond gris). SectionPliable porte deja padding + fond -> on neutralise le wrapper interne. */
.section-pliable-content > .readonly-section-content {
  padding: 0;
  background: transparent;
}

/* --- Verrou (prop \`locked\`) ---------------------------------------------------
   Valeurs reprises telles quelles de \`.opms__accordion--locked\` (SuiviOperationMSV2.css) : meme gris
   de bandeau, meme cadenas, meme precision en italique. Le motif existait deja cote MS (sections de
   l'onglet Analyse, prolongation de delai) — on le porte ici sans le redessiner, pour que les deux
   modules verrouillent a l'identique. */
.section-pliable--locked .section-pliable-header {
  background-color: #9ca3af;
  cursor: not-allowed;
}

/* Le titre porte desormais un cadenas + une precision : il devient une ligne flex. */
.section-pliable--locked .section-pliable-title {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
}

.section-pliable-lock {
  flex-shrink: 0;
  opacity: 0.85;
}

.section-pliable-hint {
  font-size: 1rem;
  font-weight: 400;
  font-style: italic;
  opacity: 0.85;
}
`, "",{"version":3,"sources":["webpack://./src/composants/SectionPliable/SectionPliable.css"],"names":[],"mappings":"AAAA,kGAAkG;AAClG;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;;;;gGAKgG;AAChG;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wFAAwF;EACxF,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA,yFAAyF;AACzF;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;4CAG4C;AAC5C;EACE,UAAU;EACV,uBAAuB;EACvB;0FACwF;EACxF,YAAY;EACZ,gBAAgB;EAChB,SAAS;AACX;;AAEA;yGACyG;AACzG;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;;;;wCAIwC;AACxC;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,qFAAqF;AACrF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":["/* Section a bandeau gris pliable, ouverte par defaut (memes codes que les sections existantes). */\n.section-pliable {\n  margin: 0 0 2rem 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n/* --- Debordement autorise (prop `overflowVisible`) ------------------------------\n   `.section-pliable` clippe son contenu : c'est ce clip qui arrondit le bas de la carte, le bloc de\n   contenu ayant un fond blanc a angles droits. Le meme clip coupe toute liste flottante en position\n   absolue — l'autocompletion d'adresse IGN devient illisible des que son champ est le dernier de la\n   section. L'opt-in leve le clip et redonne l'arrondi au bloc de contenu, qui devient alors le\n   dernier element visible de la carte : le rendu est identique, la liste n'est plus tronquee. */\n.section-pliable--overflow-visible {\n  overflow: visible;\n}\n\n.section-pliable--overflow-visible > .section-pliable-content {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n}\n\n.section-pliable-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  /* Aligne sur .section-header (TabDocuments.css) : padding 0.75rem 1rem, texte 1.4rem. */\n  padding: 0.75rem 1rem;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n  background-color: #595959;\n  color: #ffffff;\n  font-size: 1.4rem;\n  font-weight: 600;\n  cursor: pointer;\n  user-select: none;\n}\n\n.section-pliable-title {\n  flex: 1;\n  min-width: 0;\n}\n\n.section-pliable-right {\n  display: inline-flex;\n  align-items: center;\n  gap: 1rem;\n  flex-shrink: 0;\n}\n\n/* Comportement haut/bas : ouverte = fleche vers le HAUT, repliee = fleche vers le BAS. */\n.section-pliable-chevron {\n  transition: transform 0.2s ease;\n  transform: rotate(180deg);\n}\n.section-pliable-chevron.is-closed {\n  transform: rotate(0deg);\n}\n\n.section-pliable-content {\n  padding: 1.5rem;\n  background: #fff;\n}\n\n/* Sections converties qui conservent un wrapper .section-content interne\n   (Presentation, Bancaire, References) : SectionPliable porte deja padding +\n   fond. On neutralise le wrapper interne pour eviter double padding / fond gris\n   et uniformiser avec les autres onglets. */\n.section-pliable-content > .section-content {\n  padding: 0;\n  background: transparent;\n  /* .section-content global (App.css) porte aussi border + border-radius + margin-bottom :\n     a neutraliser sinon double bordure dans la carte + espace residuel sous le contenu. */\n  border: none;\n  border-radius: 0;\n  margin: 0;\n}\n\n/* Modale profil membre : les onglets ReadOnly enveloppent leur contenu dans .readonly-section-content\n   (padding + fond gris). SectionPliable porte deja padding + fond -> on neutralise le wrapper interne. */\n.section-pliable-content > .readonly-section-content {\n  padding: 0;\n  background: transparent;\n}\n\n/* --- Verrou (prop `locked`) ---------------------------------------------------\n   Valeurs reprises telles quelles de `.opms__accordion--locked` (SuiviOperationMSV2.css) : meme gris\n   de bandeau, meme cadenas, meme precision en italique. Le motif existait deja cote MS (sections de\n   l'onglet Analyse, prolongation de delai) — on le porte ici sans le redessiner, pour que les deux\n   modules verrouillent a l'identique. */\n.section-pliable--locked .section-pliable-header {\n  background-color: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Le titre porte desormais un cadenas + une precision : il devient une ligne flex. */\n.section-pliable--locked .section-pliable-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.section-pliable-lock {\n  flex-shrink: 0;\n  opacity: 0.85;\n}\n\n.section-pliable-hint {\n  font-size: 1rem;\n  font-weight: 400;\n  font-style: italic;\n  opacity: 0.85;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
